import {supabase} from './supabaseClient'

export const getOperatorStockSummary = async (zoneId: string) => {
  const {data, error} = await supabase.from('towels').select('estado').eq('zone_id', zoneId)

  if (error) throw error

  return {
    disponibles: data.filter((t) => t.estado === 'disponible').length,
    enUso: data.filter((t) => t.estado === 'en_uso').length,
    lavanderia: data.filter((t) => t.estado === 'lavanderia').length,
  }
}
